import { Plugin } from '@nuxt/types'
import { MessageProvider, initializeMessageProvider } from '@/utils/MessageProvider'

const plugin: Plugin = (_, inject) => {
  const messageProvider = new MessageProvider
  initializeMessageProvider(messageProvider)
  inject('messageProvider', messageProvider)
}

export default plugin